import React, { useState } from "react";
// import ReactStars from "react-rating-stars-component";
import starIcon from "../../images/home/star-icon.svg"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import StarRating from '../OrderDetails/starRating';
import { submitRatingdata } from "../../slices/ondcPostorderSlice";
import { useDispatch } from "react-redux";
// import { get } from "lodash";
import { notify } from "../../components/common/utils";
// import { log } from "logrocket";

const RateOrderModal = (props) => {
  const dispatch = useDispatch();
  console.log("propsprops", props);
  const itemData = props?.itemData
  const [providerRating, setProviderRating] = useState("");
  const [itemRatings, setItemRatings] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleItemRatingChange = (itemId, value) => {
    setItemRatings((prev) => ({ ...prev, [itemId]: value }));
  };

  const handleSubmit = () => {
    if (!providerRating || Object.keys(itemRatings).length === 0) {
      if (props?.orderData?.averageRating) {
        setError("Please update rating first before submitting again.");
      } else {
        setError("Please rate both provider and items.");
      }
      return;
    }
    setLoading(true)
    const user = JSON.parse(localStorage.getItem("user"));
    const ratings = [
      {
        rating_category: "provider",
        id: props?.orderData?.providerId,
        value: Number(providerRating).toString(),
      },
      ...itemData.map((item) => ({
        rating_category: "item",
        id: item.id,
        value: Number(itemRatings[item.id]).toString(),
      })),
    ];

    const payload = {
      userId: user?._id,
      orderId: props?.orderData?._id,
      ondcOrderId: props?.orderData?.ondcOrderId,
      transactionId: props?.orderData?.transactionId,
      providerId: props?.orderData?.providerId,
      ratings,
    };

    dispatch(submitRatingdata(payload)).then((data) => {
      // console.log("datadatadata",data)
      if (data?.payload?.data && data?.payload?.success) {
        props.getOrderDetail();
        notify("success", data?.payload?.message);
        props?.setRatingModal(false)
      } else {
        notify("error", "Something went wrong. Please try again later.");
        props?.setRatingModal(false)
        // setErrors((prevErrors) => ({
        //   ...prevErrors,
        //   commonError: "Something went wrong. Please try again later.",
        // }));
      }
      setLoading(false)
    })
  };

  return (
    <Modal
      isOpen={props?.ratingModal}
      size="md"
      centered
      // toggle={() => props?.setRatingModal(false)}
      className="custom-modal-kl rate-order-modal-kl"
    >
      <ModalHeader toggle={() => props?.setRatingModal(false)}>
        <h1 className="modal-title fs-5" id="staticBackdropLabel">
          Rate Order
        </h1>
      </ModalHeader>
      <ModalBody>
        <div className="rate-order-modal-card-kl">
          <div className="rate-order-modal-header-kl">
            <div className="rate-order-modal-title-kl">Rate Your Order</div>
          </div>
          <div className="rate-order-modal-content-kl">
            <div className="rate-order-list-kl">
              <div className="rate-order-item-kl">
                <div className="d-flex align-content-center gap-2">
                  <div className="rate-order-product-kl">
                    <img src={props?.orderData?.sellerData?.photo} alt="product" className="rate-order-product-image-kl" />
                  </div>
                  <div>
                    <div className="rate-order-item-title-kl">{props?.orderData?.delivery?.['@ondc/org/provider_name']}</div>
                    <div className="rate-order-item-sub-title-kl">
                      {[
                        props?.orderData?.delivery?.start?.location?.address?.locality,
                        props?.orderData?.delivery?.start?.location?.address?.city,
                        props?.orderData?.delivery?.start?.location?.address?.state
                      ]
                        .filter(Boolean)
                        .join(', ')}

                      {/* Lal Banglore Bazaaar, Banglore */}
                    </div>
                  </div>
                </div>
                {props?.orderData?.sellerData?.averageRating &&
                  <div className="rate-order-rating-number-kl">
                    <img src={starIcon} alt="star" className="star-icon" />
                    {props?.orderData?.sellerData?.averageRating
                      ? Number(props?.orderData?.sellerData?.averageRating).toFixed(1)
                      : 'N/A'}
                  </div>
                }
              </div>
            </div>
            <div className="rate-order-rating-container-kl">
              <div className="rate-order-rating-title-kl">
                Rate Here
              </div>
              {/* <ReactStars
              count={5}
              onChange={ratingChanged}
              size={24}
              isHalf={true}
              emptyIcon={<i className="far fa-star"></i>}
              halfIcon={<i className="fa fa-star-half-alt"></i>}
              fullIcon={<i className="fa fa-star"></i>}
              activeColor="#ffd700"
              ratingColor='green'
              reviewText='Rate Your Order'
              reviewTextColor='white'
              reviewColor='red'
              reviewBackgroundColor='#000'
              ratingBackgroundColor='#c8c7c8'
              tintColor='#000 !important'
              style={{ paddingVertical: 10, }}                      
            />  */}
              <StarRating
                value={providerRating || props?.orderData?.averageRating}
                onChange={(value) => setProviderRating(value)}
              />
            </div>
          </div>
        </div>
        <div className="rate-order-modal-card-kl">
          <div className="rate-order-modal-header-kl">
            <div className="rate-order-modal-title-kl">Rate Product</div>
          </div>
          <div className="rate-order-modal-content-kl">
            {itemData.map((item) => (
              <div className="rate-order-list-kl">
                <div className="rate-order-item-kl mb-0">
                  <div className="d-flex align-content-center gap-2">
                    <div className="rate-order-product-title-kl text-truncate">
                      {item?.productName}
                      {/* Aashirvaad Superior MP Atta (Genhu Ka At */}
                    </div>
                  </div>
                  {item?.averageRating &&
                    <div className="rate-order-rating-number-kl">
                      <img src={starIcon} alt="star" className="star-icon" />
                      {item?.averageRating ? Number(item?.averageRating).toFixed(1) : 'N/A'}
                    </div>
                  }
                </div>
                <div className="rate-order-rating-container-kl mb-2">
                  {/* <ReactStars
                count={5}
                onChange={ratingChanged}
                size={24}
                isHalf={true}
                emptyIcon={<i className="far fa-star"></i>}
                halfIcon={<i className="fa fa-star-half-alt"></i>}
                fullIcon={<i className="fa fa-star"></i>}
                activeColor="#ffd700"
              /> */}
                  <StarRating
                    value={itemRatings[item?.id] || item?.rating}
                    onChange={(value) => handleItemRatingChange(item.id, value)}
                  />
                </div>
              </div>
            ))}

          </div>
        </div>
        {error && <p className="error text-danger">{error}</p>}
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="btn btn-outline-gray"
          // data-bs-dismiss="modal"
          onClick={() => props?.setRatingModal(false)}
        >
          Cancel
        </button>
        <button 
        disabled={loading || props?.orderData?.averageRating}
        type="button" className="btn btn-primary" onClick={handleSubmit}>
          {loading ?
            "Please Wait..." :
            "Submit"}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default RateOrderModal;
